import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {sortBy} from 'ramda';
import Pagination from 'react-bootstrap/lib/Pagination';
// import Switch from 'react-bootstrap-switch';
import DashboardProject from '../../components/Sections/Dashboard/DashboardProject';
import DashboardSelect from '../../components/Sections/Dashboard/DashboardSelect';
import ServicesLink from '../../components/Sections/MainPage/ServicesLink';
import util from '../../lib/util';
import { browserHistory } from 'react-router';



class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    props.dispatch({ type: 'INITIALIZE_DASHBOARD' });
    props.dispatch({ type: 'INITIALIZE_API', user: this.props.user });
    this.state = { activePage: 1, rpp: 5, isDataLoaded: false };
  }

  componentWillReceiveProps(p) {
    if (p.user && !p.user.isAuthenticated) {
      browserHistory.push('/login');
      return;
    }
    if (p.user && p.user.isAuthenticated && !this.state.isDataLoaded) {
      p.dispatch({ type: 'GET_PROJECT_LIST', bp: p.user && p.user.bpNumber });
      this.setState({ isDataLoaded: true });
    }
  }

  changePage = e => {
    this.setState({ activePage: e });
  };

  changeRpp = e => {
    this.setState({ activePage: 1, rpp: +e.target.value });
  };

  // switch = (e, s) => {
  //   this.props.dispatch({ type: 'DB_SWITCH', on: s, prjs: this.getSubmittedList(this.getFilteredList()).map(x => x.projectNo)  });
  // } 

  switchProject = p => {
    this.props.dispatch({ type: 'DB_SWITCH_PROJECT', prjNo: p.projectNo, on: !p.isAllEmail });
  };

  getFilteredList = () => {
    const lu = window.osa && window.osa.lookup;
    const p = this.props;
    let lst = p.prjList || [];
    if (p.filterByType && p.filterByType != 'All')
      lst = lst.filter(x => lu.serviceType && lu.serviceType[x.applicationType] === p.filterByType);
    if (p.filterByCity && p.filterByCity != 'All')
      lst = lst.filter(x => x.siteAddress.city.toLowerCase() === p.filterByCity.toLowerCase());
    if (p.filterByStatus && p.filterByStatus != 'All')
      lst = lst.filter(x => x.status.toLowerCase() === p.filterByStatus.toLowerCase());
    if (p.sortBy && p.sortBy != 'None') {
      if (p.sortBy === 'Creation date')
        lst = sortBy(x => x.createdDate, lst);
      else if (p.sortBy === 'Scheduled date')
        lst = sortBy(x => x.scheduleStartDate, lst);
    }
    return lst;
  };

  getSubmittedList = lst => lst.filter(x => x.status.toLowerCase() === 'submitted');

  render() {
    const all = [{ id: 'All', name: 'All' }];
    const lu = window.osa && window.osa.lookup;
    const cl = window.osa && window.osa.commonLookup && window.osa.commonLookup;
    const lst = this.getFilteredList();
    // const lstSubmitted = this.getSubmittedList(lst);
    // const isAllTrue = lstSubmitted.length > 0 && lstSubmitted.every(x => x.isAllEmail);
    // const isAllFalse = lstSubmitted.length === 0 || lstSubmitted.every(x => !x.isAllEmail);
    // const isAll = isAllTrue ? true : (isAllFalse ? false : null);
    const s = this.state;
    const si = (s.activePage - 1) * s.rpp;
    const ei = si + s.rpp;
    return (
      <div className="container">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <ServicesLink lookup={cl && cl.services} />
        </div>
        <h3 style={{ color: "#002a49" }}>Existing Service requests</h3>
        <hr />

        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-3">
            <DashboardSelect name="dashboardFilterByType" label="Request type"
              items={all.concat(Object.keys(lu && lu.serviceType || {}).map(x => ({ id: lu && lu.serviceType[x], name: lu && lu.serviceType[x] })))} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-3">
            <DashboardSelect name="dashboardFilterByCity" label="Search by city"
              items={all.concat((window.osa && window.osa.cities || []).map(x => ({ id: x, name: x })))} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-3">
            <DashboardSelect name="dashboardFilterByStatus" label="Show requests"
              items={all.concat(Object.keys(lu && lu.status || {}).map(x => ({ id: x, name: x })))} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-3">
            <DashboardSelect name="dashboardSortBy" label="Sort by"
              items={(lu && lu.sortBy || []).map(x => ({ id: x, name: x }))} />
          </div>
        </div>

        <div className="row">
          <hr className="soften" style={{ marginTop: "5px" }} />
          <div className="col-md-12">
            <div className="row" style={{ borderBottom: "0px solid #dddddd", paddingBottom: "0px", paddingTop: "0px" }}>
              <div className="col-md-8"><h5 style={{ fontWeight: "bold", marginTop: "0px", marginBottom: "0px" }}>Projects</h5></div>
              <div className="col-md-2" />
              <div className="col-md-2" style={{ marginBottom: "0px", marginLeft: "0px", padding: "0px" }}>
                {/*<h5 style={{ textAlign: "left", fontWeight: "bold", marginTop: "0px", marginBottom: "0px" }}>All email notifications</h5>*/}
              </div>
            </div>
            <div className="row" style={{ borderBottom: "2px solid #dddddd", paddingBottom: "0px" }}>
              <div className="col-md-8" />
              <div className="col-md-2 text-right" />
              <div className="col-md-2" style={{ marginBottom: "0px", marginLeft: "-20px", padding: "0px" }}>
                <div className="checkbox" style={{ marginTop: "10px", marginLeft: "20px" }}>
                  {/*<Switch bsSize="mini" value={isAll} onChange={this.switch}/>*/}
                </div>
              </div>
            </div>
            {lst.slice(si, ei).map(x => <DashboardProject project={x} key={x.projectNo}
              address={util.toCafeAddress(x.siteAddress)} switchProject={this.switchProject} />)}
          </div>
        </div>
        <div className="row" style={{ paddingTop: "10px" }}>
          <div className="col-xs-1 col-sm-1 text-right">View </div>
          <div className="form-group col-xs-6 col-sm-2">
            <select name="viewby" className="form-control" onChange={this.changeRpp} value={s.rpp}>
              {(lu && lu.itemsPerPage || []).map(x => <option key={x} value={x}>{x}</option>)}
            </select>
          </div>
          <div className="col-xs-9 col-sm-9 text-left">
            records at a time.
                </div>
        </div>
        <div className="row">
          <Pagination prev next first last ellipsis boundaryLinks items={Math.ceil(lst.length / s.rpp)} maxButtons={10} activePage={s.activePage} onSelect={this.changePage} />
        </div>
      </div>
    );
  }
}
Dashboard.propTypes = {
  dispatch: PropTypes.func,
  user: PropTypes.Object,
  prjList: PropTypes.Object,
  filterByType: PropTypes.string,
  sortBy: PropTypes.string
};

export default connect(s => ({
  user: s.gas.user,
  prjList: s.gas.prjList,
  filterByType: s.form.dashboardFilterByType,
  filterByCity: s.form.dashboardFilterByCity,
  filterByStatus: s.form.dashboardFilterByStatus,
  sortBy: s.form.dashboardSortBy
}))(Dashboard);